export function computePayment(terms) {
  const P = Number(terms.credit_limit || 0);
  const freq = terms.payment_frequency || "monthly";
  const periodsPerYear = { daily: 252, weekly: 52, "bi-weekly": 26, monthly: 12 }[freq] || 12;
  const termValue = Number(terms.repayment_term_value || 0);
  const termUnit = terms.repayment_term_unit || "months";
  const termYears = termValue ? termValue / (termUnit === "months" ? 12 : 52) : 0;
  const n = Math.max(1, Math.round(termYears * periodsPerYear));

  let origFee = 0;
  if (terms.origination_fee_type === "pct") origFee = (P * Number(terms.origination_fee_value || 0)) / 100;
  else origFee = Number(terms.origination_fee_value || 0);

  let payment, totalPayback;
  if (terms.pricing_mode === "factor") {
    const factor = Number(terms.factor_rate || 1);
    totalPayback = P * factor;
    payment = n ? totalPayback / n : 0;
  } else {
    const apr = Number(terms.apr || 0) / 100;
    const r = apr / periodsPerYear;
    payment = r > 0 ? (P * r) / (1 - Math.pow(1 + r, -n)) : n ? P / n : 0;
    totalPayback = payment * n;
  }
  return {
    estimated_payment: Math.round(payment * 100) / 100,
    payment_frequency: freq,
    number_of_payments: n,
    total_payback: Math.round(totalPayback * 100) / 100,
    origination_fee: Math.round(origFee * 100) / 100,
    total_cost_of_capital: Math.round((totalPayback - P + origFee) * 100) / 100,
  };
}

export function computeDraw(terms, amount) {
  const P = Number(amount || 0);
  const freq = terms.payment_frequency || "monthly";
  const periodsPerYear = { daily: 252, weekly: 52, "bi-weekly": 26, monthly: 12 }[freq] || 12;
  const termValue = Number(terms.repayment_term_value || 0);
  const termUnit = terms.repayment_term_unit || "months";
  const termYears = termValue ? termValue / (termUnit === "months" ? 12 : 52) : 0;
  const n = Math.max(1, Math.round(termYears * periodsPerYear));
  let payment, totalPayback;
  if (terms.pricing_mode === "factor") {
    const factor = Number(terms.factor_rate || 1);
    totalPayback = P * factor;
    payment = n ? totalPayback / n : 0;
  } else {
    const apr = Number(terms.apr || 0) / 100;
    const r = apr / periodsPerYear;
    payment = r > 0 ? (P * r) / (1 - Math.pow(1 + r, -n)) : n ? P / n : 0;
    totalPayback = payment * n;
  }
  const drawFee = (P * Number(terms.draw_fee_pct || 0)) / 100;
  return {
    draw_amount: Math.round(P * 100) / 100,
    draw_fee: Math.round(drawFee * 100) / 100,
    net_funded: Math.round((P - drawFee) * 100) / 100,
    estimated_payment: Math.round(payment * 100) / 100,
    payment_frequency: freq,
    number_of_payments: n,
    total_payback: Math.round(totalPayback * 100) / 100,
    total_cost_of_capital: Math.round((totalPayback - P + drawFee) * 100) / 100,
  };
}

export const PRESET_DOCS = [
  "Last 3 months business bank statements",
  "Last 4 months business bank statements",
  "Last 6 months business bank statements",
  "Most recent business tax return",
  "Personal tax return",
  "Driver's license (front/back)",
  "Voided business check",
  "Proof of ownership / Articles of Organization",
  "EIN letter (SS-4/CP-575)",
  "Profit & Loss statement",
  "Balance sheet",
  "Accounts receivable aging",
  "Business debt schedule",
  "Lease agreement or mortgage statement",
  "Business insurance certificate",
];
